import { CIcon } from '~/icons/types'
export const ciNotifications: CIcon = {
  name: 'notifications',
  type: 'light',
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M20.9 15.3c-1.4-1.5-2.1-3.5-2.1-5.5V9c0-3.7-3-6.8-6.8-6.8-3.7 0-6.8 3-6.8 6.8v.8c0 2-.8 4-2.1 5.5-.1.2-.2.4-.1.7.1.3.2.4.5.5 1.6.6 3.2 1 4.8 1.2v.3c0 2.1 1.7 3.8 3.8 3.8 2.1 0 3.8-1.7 3.8-3.8v-.3c1.6-.2 3.3-.7 4.8-1.2.2-.1.4-.3.5-.5.1-.2-.2-.5-.3-.7ZM12 20.2c-1.2 0-2.2-1-2.2-2.2v-.1c1.5.1 3 .1 4.5 0v.1c-.1 1.2-1.1 2.2-2.3 2.2Zm2.8-3.9c-1.9.2-3.7.2-5.5 0-1.5-.2-2.9-.5-4.3-.9 1.2-1.6 1.8-3.6 1.8-5.7V9c0-2.9 2.4-5.2 5.2-5.2 2.9 0 5.2 2.4 5.2 5.3v.7c0 2 .6 4 1.8 5.7-1.3.4-2.8.7-4.2.8Z'
    }
  ]
}
